export enum StockInType {
    NKHangDaNhan = 1,
    NKHangTrungChuyen = 2,
    NKHangMoiTao = 3
}